import { apiCall } from "api/axios";
import { IGetIndividualAccountsPayload } from "contexts/individuals-context/types";
import { getTodayAsEndDateFilterValue } from "utils";

import {
  ICloseIndividualSavingsPayload,
  ICloseIndividualSavingsResponseData,
  IDeactivateOdpAccessPayload,
  IDeactivateOdpAccessResponseData,
  IExportAccountTransactionsPayload,
  IExportLoansPayload,
  IExportResponseData,
  IExportSavingsHistoryPayload,
  IExportSavingsPayload,
  IExportWithdrawalHistoryPayload,
  IFreezeAccountTotallyPayload,
  IFreezeAccountTotallyResponseData,
  IFreezeIndividualTotallyPayload,
  IFreezeIndividualTotallyResponseData,
  IGenerateAccountStatementPayload,
  IGenerateAccountStatementResponseData,
  IGetAccountTransactionsDetailsPayload,
  IGetAccountTransactionsPayload,
  IGetAccountTransactionsStatsPayload,
  IGetIndividualDetailsPayload,
  IGetIndividualStatsPayload,
  IGetIndividualTransactionLimitSettingsPayload,
  IGetODPDetailsPayload,
  IGetOdpWithdrawalHistoryPayload, // IIndividualAccountTransactionsDetailsResponseData, // IIndividualAccountTransactionsDetailsResponseData,
  IIndividualAccountTransactionsResponseData,
  IIndividualAccountTransactionsStatsResponseData,
  IIndividualAccountTransactionsViewDetailsResponseData, // IIndividualAccountTransactionsViewDetailsResponseData,
  IIndividualAccountsResponseData,
  IIndividualActivateOrDeactivatePayload,
  IIndividualActivateOrDeactivateResponseData,
  IIndividualDetailsResponseData,
  IIndividualListPayload,
  IIndividualLoansDetailsPayload,
  IIndividualLoansDetailsResponseData,
  IIndividualLoansPayload,
  IIndividualLoansResponseData,
  IIndividualSavingsDetailsPayload,
  IIndividualSavingsDetailsResponseData,
  IIndividualSavingsHistoryPayload,
  IIndividualSavingsHistoryResponseData,
  IIndividualSavingsPayload,
  IIndividualSavingsResponseData,
  IIndividualSavingsStatsPayload,
  IIndividualSavingsStatsResponseData,
  IIndividualSavingsTransactionsStatsPayload,
  IIndividualSavingsTransactionsStatsResponseData,
  IIndividualStatsResponseData,
  IIndividualTransactionLimitSettingsResponseData,
  IIndividualTransactionResponseData,
  IIndividualTransactionsPayload, // IIndividualsExportPayload,
  // IIndividualsExportResponseData,
  IIndividualsListResponseData,
  IPauseIndividualSavingsPayload,
  IPauseIndividualSavingsResponseData,
  IResendOdpInvitePayload,
  IResendOdpInviteResponseData,
  IResumeIndividualSavingsPayload,
  IResumeIndividualSavingsResponseData, // IODPDetailsResponseData,
  IUpdateIndividualProfilePayload,
  IUpdateIndividualProfileResponseData,
  IUserODPDetailsResponseData,
  IUserOdpWithdrawalHistoryResponseData,
} from "./types";

export const getIndividualsStats = async (
  payload: IGetIndividualStatsPayload
) => {
  const payloadData = { ...payload };
  if (payloadData.startDate && !payloadData.endDate) {
    payloadData.endDate = getTodayAsEndDateFilterValue();
  }
  const queryString = Object.entries(payloadData)
    .filter(([_, value]) => value !== undefined && value !== null)
    .map(
      ([key, value]) =>
        `${encodeURIComponent(key)}=${encodeURIComponent(value)}`
    )
    .join("&");

  const result = await apiCall({
    apiRoute: `/control/personal/user-management/user-stats${queryString ? `?${queryString}` : ""}`,
    module: "EARNIPAY_API",
    config: {
      method: "GET",
    },
    useEncryption: true,
  });
  return result as IIndividualStatsResponseData;
};

export const getIndividualsData = async (payload: IIndividualListPayload) => {
  delete payload.isRefetching;
  const payloadData = { ...payload };
  if (payloadData.startDate && !payloadData.endDate) {
    payloadData.endDate = getTodayAsEndDateFilterValue();
  }
  const queryString = Object.entries(payloadData)
    .filter(([_, value]) => value !== undefined && value !== null)
    .map(
      ([key, value]) =>
        `${encodeURIComponent(key)}=${encodeURIComponent(value)}`
    )
    .join("&");
  const result = await apiCall({
    apiRoute: `/control/personal/user-management/users?${queryString}`,
    module: "EARNIPAY_API",
    config: {
      method: "GET",
    },
    useEncryption: true,
  });
  return result as IIndividualsListResponseData;
};

// export const exportIndividuals = async (payload: IIndividualsExportPayload) => {
//   const data = { ...payload };
//   if (data.startDate && !data.endDate) {
//     data["endDate"] = getTodayAsEndDateFilterValue();
//   }
//   const result = await apiCall({
//     apiRoute: "/control/personal/user-management/users-export",
//     module: "EARNIPAY_API",
//     config: {
//       method: "POST",
//       data,
//     },
//     useEncryption: true,
//   });
//   return result as IIndividualsExportResponseData;
// };

export const getIndividualDetails = async (
  payload: IGetIndividualDetailsPayload
) => {
  const result = await apiCall({
    apiRoute: "/control/personal/user-management/users",
    module: "EARNIPAY_API",
    config: {
      method: "POST",
      data: payload,
    },
    useEncryption: true,
  });
  return result as IIndividualDetailsResponseData;
};

export const updateIndividualProfile = async (
  payload: IUpdateIndividualProfilePayload
) => {
  const result = await apiCall({
    apiRoute: "/control/personal/user-management/users",
    module: "EARNIPAY_API",
    config: {
      method: "PATCH",
      data: payload,
    },
    useEncryption: true,
  });
  return result as IUpdateIndividualProfileResponseData;
};

export const freezeAccountTotally = async (
  payload: IFreezeAccountTotallyPayload
) => {
  const result = await apiCall({
    apiRoute: "/control/personal/user-management/account/freeze-unfreeze",
    module: "EARNIPAY_API",
    config: {
      method: "PATCH",
      data: payload,
    },
    useEncryption: true,
  });
  return result as IFreezeAccountTotallyResponseData;
};

export const freezeIndividualTotally = async (
  payload: IFreezeIndividualTotallyPayload
) => {
  const result = await apiCall({
    apiRoute: "/control/personal/user-management/accounts/freeze-unfreeze",
    module: "EARNIPAY_API",
    config: {
      method: "PATCH",
      data: payload,
    },
    useEncryption: true,
  });
  return result as IFreezeIndividualTotallyResponseData;
};

export const activateOrDeactivateIndividual = async (
  payload: IIndividualActivateOrDeactivatePayload
) => {
  const result = await apiCall({
    apiRoute: "/control/personal/user-management/activate-deactivate",
    module: "EARNIPAY_API",
    config: {
      method: "PATCH",
      data: payload,
    },
    useEncryption: true,
  });
  return result as IIndividualActivateOrDeactivateResponseData;
};

export const getIndividualAccounts = async (
  payload: IGetIndividualAccountsPayload
) => {
  const result = await apiCall({
    apiRoute: "/control/personal/user-management/accounts",
    module: "EARNIPAY_API",
    config: {
      method: "POST",
      data: payload,
    },
    useEncryption: true,
  });
  return result as IIndividualAccountsResponseData;
};

export const generateAccountStatement = async (
  payload: IGenerateAccountStatementPayload
) => {
  if (payload.startDate && !payload.endDate) {
    payload.endDate = getTodayAsEndDateFilterValue(); //to update the end date to same day
  }
  const result = await apiCall({
    apiRoute: "/control/personal/user-management/account/generate-statement",
    module: "EARNIPAY_API",
    config: {
      method: "POST",
      data: payload,
    },
    useEncryption: true,
  });
  return result as IGenerateAccountStatementResponseData;
};

export const getAccountsTransactionsStat = async (
  payload: IGetAccountTransactionsStatsPayload
) => {
  const result = await apiCall({
    apiRoute: "/control/personal/user-management/accounts/transactions/stat",
    module: "EARNIPAY_API",
    config: {
      method: "POST",
      data: payload,
    },
    useEncryption: true,
  });
  return result as IIndividualAccountTransactionsStatsResponseData;
};

export const getAccountsTransactions = async (
  payload: IGetAccountTransactionsPayload
) => {
  const data = { ...payload };
  if (data.startDate && !data.endDate) {
    data["endDate"] = getTodayAsEndDateFilterValue();
  }

  const result = await apiCall({
    apiRoute: "/control/personal/user-management/accounts/transactions",
    module: "EARNIPAY_API",
    config: {
      method: "POST",
      data,
    },
    useEncryption: true,
  });
  return result as IIndividualAccountTransactionsResponseData;
};

export const getAccountsTransactionsDetail = async (
  payload: IGetAccountTransactionsDetailsPayload
) => {
  const data = { ...payload };
  if (data.startDate && !data.endDate) {
    data["endDate"] = getTodayAsEndDateFilterValue();
  }

  const result = await apiCall({
    apiRoute: "/control/personal/user-management/accounts/transactions/detail",
    module: "EARNIPAY_API",
    config: {
      method: "POST",
      data,
    },
    useEncryption: true,
  });
  return result as IIndividualAccountTransactionsViewDetailsResponseData;
};

export const getIndividualTransactions = async (
  payload: IIndividualTransactionsPayload
) => {
  if (payload.startDate && !payload.endDate) {
    payload.endDate = getTodayAsEndDateFilterValue(); //to update the end date to same day
  }
  const result = await apiCall({
    apiRoute: "/control/personal/user-management/transactions",
    module: "EARNIPAY_API",
    config: {
      method: "POST",
      data: payload,
    },
    useEncryption: true,
  });
  return result as IIndividualTransactionResponseData;
};

export const exportAccountTransactions = async (
  payload: IExportAccountTransactionsPayload
) => {
  const data = { ...payload };
  if (data.startDate && !data.endDate) {
    data["endDate"] = getTodayAsEndDateFilterValue();
  }
  const result = await apiCall({
    apiRoute: "/control/personal/user-management/user-transactions-export",
    module: "EARNIPAY_API",
    config: {
      method: "POST",
      data,
    },
    useEncryption: true,
  });
  return result as IExportResponseData;
};

// Loans Section
export const getIndividualLoans = async (payload: IIndividualLoansPayload) => {
  if (payload.startDate && !payload.endDate) {
    payload.endDate = getTodayAsEndDateFilterValue(); //to update the end date to same day
  }
  const result = await apiCall({
    apiRoute: "/control/personal/user-management/loans",
    module: "EARNIPAY_API",
    config: {
      method: "POST",
      data: payload,
    },
    useEncryption: true,
  });
  return result as IIndividualLoansResponseData;
};

export const getIndividualLoansDetails = async (
  payload: IIndividualLoansDetailsPayload
) => {
  const result = await apiCall({
    apiRoute: "/control/personal/user-management/loan/details",
    module: "EARNIPAY_API",
    config: {
      method: "POST",
      data: payload,
    },
    useEncryption: true,
  });
  return result as IIndividualLoansDetailsResponseData;
};

// Savings Section

export const getIndividualSavingsTransactionsStats = async (
  payload: IIndividualSavingsTransactionsStatsPayload
) => {
  const result = await apiCall({
    apiRoute: "/control/personal/user-management/savings/transactions/stat",
    module: "EARNIPAY_API",
    config: {
      method: "POST",
      data: payload,
    },
    useEncryption: true,
  });
  return result as IIndividualSavingsTransactionsStatsResponseData;
};

export const getIndividualSavingsStats = async (
  payload: IIndividualSavingsStatsPayload
) => {
  const result = await apiCall({
    apiRoute: "/control/personal/user-management/savings/stat",
    module: "EARNIPAY_API",
    config: {
      method: "POST",
      data: payload,
    },
    useEncryption: true,
  });
  return result as IIndividualSavingsStatsResponseData;
};

export const getIndividualSavings = async (
  payload: IIndividualSavingsPayload
) => {
  if (payload.startDate && !payload.endDate) {
    payload.endDate = getTodayAsEndDateFilterValue(); //to update the end date to same day
  }

  const result = await apiCall({
    apiRoute: "/control/personal/user-management/savings",
    module: "EARNIPAY_API",
    config: {
      method: "POST",
      data: payload,
    },
    useEncryption: true,
  });
  return result as IIndividualSavingsResponseData;
};

export const getIndividualSavingsDetails = async (
  payload: IIndividualSavingsDetailsPayload
) => {
  const result = await apiCall({
    apiRoute: "/control/personal/user-management/savings/detail",
    module: "EARNIPAY_API",
    config: {
      method: "POST",
      data: payload,
    },
    useEncryption: true,
  });
  return result as IIndividualSavingsDetailsResponseData;
};

export const getIndividualSavingsHistory = async (
  payload: IIndividualSavingsHistoryPayload
) => {
  if (payload.startDate && !payload.endDate) {
    payload.endDate = getTodayAsEndDateFilterValue(); //to update the end date to same day
  }
  const result = await apiCall({
    apiRoute: "/control/personal/user-management/savings/transactions",
    module: "EARNIPAY_API",
    config: {
      method: "POST",
      data: payload,
    },
    useEncryption: true,
  });
  return result as IIndividualSavingsHistoryResponseData;
};

export const pauseIndividualSavings = async (
  payload: IPauseIndividualSavingsPayload
) => {
  const result = await apiCall({
    apiRoute: "/control/personal/user-management/savings/pause",
    module: "EARNIPAY_API",
    config: {
      method: "PATCH",
      data: payload,
    },
    useEncryption: true,
  });
  return result as IPauseIndividualSavingsResponseData;
};

export const resumeIndividualSavings = async (
  payload: IResumeIndividualSavingsPayload
) => {
  const result = await apiCall({
    apiRoute: "/control/personal/user-management/savings/resume",
    module: "EARNIPAY_API",
    config: {
      method: "PATCH",
      data: payload,
    },
    useEncryption: true,
  });
  return result as IResumeIndividualSavingsResponseData;
};

export const closeIndividualSavings = async (
  payload: ICloseIndividualSavingsPayload
) => {
  const result = await apiCall({
    apiRoute: "/control/personal/user-management/savings/close",
    module: "EARNIPAY_API",
    config: {
      method: "POST",
      data: payload,
    },
    useEncryption: true,
  });
  return result as ICloseIndividualSavingsResponseData;
};

export const exportAccountSavings = async (payload: IExportSavingsPayload) => {
  const data = { ...payload };
  if (data.startDate && !data.endDate) {
    data["endDate"] = getTodayAsEndDateFilterValue();
  }
  const result = await apiCall({
    apiRoute: "/control/personal/user-management/savings-transaction-export",
    module: "EARNIPAY_API",
    config: {
      method: "POST",
      data,
    },
    useEncryption: true,
  });
  return result as IExportResponseData;
};

export const exportLoans = async (payload: IExportLoansPayload) => {
  const data = { ...payload };
  if (data.startDate && !data.endDate) {
    data["endDate"] = getTodayAsEndDateFilterValue();
  }
  const result = await apiCall({
    apiRoute: "/control/personal/user-management/loans-export",
    module: "EARNIPAY_API",
    config: {
      method: "POST",
      data,
    },
    useEncryption: true,
  });
  return result as IExportResponseData;
};

export const exportSavings = async (payload: IExportSavingsPayload) => {
  const data = { ...payload };
  if (data.startDate && !data.endDate) {
    data["endDate"] = getTodayAsEndDateFilterValue();
  }
  const result = await apiCall({
    apiRoute: "/control/personal/user-management/savings/export",
    module: "EARNIPAY_API",
    config: {
      method: "POST",
      data,
    },
    useEncryption: true,
  });
  return result as IExportResponseData;
};

export const exportSavingsHistory = async (
  payload: IExportSavingsHistoryPayload
) => {
  const data = { ...payload };
  if (data.startDate && !data.endDate) {
    data["endDate"] = getTodayAsEndDateFilterValue();
  }
  const result = await apiCall({
    apiRoute: "/control/personal/user-management/savings/transactions-export",
    module: "EARNIPAY_API",
    config: {
      method: "POST",
      data,
    },
    useEncryption: true,
  });
  return result as IExportResponseData;
};

// ODP Section

export const getODPDetails = async (payload: IGetODPDetailsPayload) => {
  const result = await apiCall({
    apiRoute: "/control/personal/user-management/odp/details",
    module: "EARNIPAY_API",
    config: {
      method: "POST",
      data: payload,
    },
    useEncryption: true,
  });
  return result as IUserODPDetailsResponseData;
};

export const getOdpWithdrawalHistory = async (
  payload: IGetOdpWithdrawalHistoryPayload
) => {
  const data = { ...payload };
  if (data.startDate && !data.endDate) {
    data["endDate"] = getTodayAsEndDateFilterValue();
  }
  const result = await apiCall({
    apiRoute: "/control/personal/user-management/odp/withdrawals",
    module: "EARNIPAY_API",
    config: {
      method: "POST",
      data,
    },
    useEncryption: true,
  });
  return result as IUserOdpWithdrawalHistoryResponseData;
};

export const exportWithdrawalHistory = async (
  payload: IExportWithdrawalHistoryPayload
) => {
  const data = { ...payload };
  if (data.startDate && !data.endDate) {
    data["endDate"] = getTodayAsEndDateFilterValue();
  }
  const result = await apiCall({
    apiRoute: "/control/personal/user-management/odp-export",
    module: "EARNIPAY_API",
    config: {
      method: "POST",
      data,
    },
    useEncryption: true,
  });
  return result as IExportResponseData;
};

export const resendOdpInvite = async (payload: IResendOdpInvitePayload) => {
  const result = await apiCall({
    apiRoute: "/control/personal/user-management/odp/resend-invite",
    module: "EARNIPAY_API",
    config: {
      method: "PATCH",
      data: payload,
    },
    useEncryption: true,
  });
  return result as IResendOdpInviteResponseData;
};

export const deactivateOdpAccess = async (
  payload: IDeactivateOdpAccessPayload
) => {
  const result = await apiCall({
    apiRoute: "/control/personal/user-management/odp/deactivate",
    module: "EARNIPAY_API",
    config: {
      method: "POST",
      data: payload,
    },
    useEncryption: true,
  });
  return result as IDeactivateOdpAccessResponseData;
};
//EXTRAS

export const getIndividualTransactionLimitSettings = async (
  payload: IGetIndividualTransactionLimitSettingsPayload
) => {
  const result = await apiCall({
    apiRoute: "/control/individual/compliance/transaction-limit",
    module: "EARNIPAY_API",
    config: {
      method: "POST",
      data: payload,
    },
    useEncryption: true,
  });
  return result as IIndividualTransactionLimitSettingsResponseData;
};
